module.exports = __webpack_public_path__ + "img/stock-active.396cf395.png";